// the purpose of this script is to stop people from submiting the 2FA token form twice

document.addEventListener(
  'DOMContentLoaded',
  function (e) {
    const checkForm = function (e) {
      const form = e.target;
      form.submit_button.value = 'Submitting form...';
      form.submit_button.disabled = true;
    };

    const form = document.getElementById('2FALoginForm');

    if (form) {
      form.addEventListener('submit', checkForm, false);
    }
  },
  false,
);
